'use client';

import { useRouter } from 'next/navigation';
import { Button, type ButtonProps } from '@/components/ui/Button';
import { logout } from '@/lib/auth/auth-service';

interface LogoutButtonProps {
  className?: string;
  redirectTo?: string;
  size?: ButtonProps['size'];
  variant?: ButtonProps['variant'];
}

export function LogoutButton({
  className,
  redirectTo = '/login',
  size = 'sm',
  variant = 'secondary',
}: LogoutButtonProps) {
  const router = useRouter();

  const handleLogout = () => {
    logout();

    if (redirectTo) {
      router.replace(redirectTo);
      return;
    }

    router.refresh();
  };

  return (
    <Button className={className} variant={variant} size={size} type="button" onClick={handleLogout}>
      Cerrar sesion
    </Button>
  );
}
